export default {
  // mall: {
  //   StartTime: '开始时间',
  //   EndTime: '结束时间',
  //   ToProcessDate: '去程日期',
  //   backTracking: '返程日期',
  //   sharing: '共享',
  //   AirplaneModelTxt: '机型',
  //   ticketfeeFloat: '此价格不含机建燃油税费',
  //   peopleTypeExplain: '儿童婴儿预订说明',
  //   bookingTicketExplain: '如需预订儿童/婴儿票，请联系本公司客服。',
  //   onlySeeDirect: '仅看直飞',
  //   hiddenSharedFlight: '隐藏共享航班',
  //   ActualCarrier: '实际承运',
  //   stayTxt: '停留',
  //   turnTxt: '转',
  //   priceRemarks: '以下费用均为“1成人或1儿童或1婴儿”的人均价',
  //   AgreementPrice: '协议价',
  //   tax: '税',
  //   trainHolderKeyWords: '国内火车票',
  //   bookingRemarks: '一次最多只能预订5位乘客',
  //   beginTxt: '始',
  //   passTxt: '过',
  //   endTxt: '终',
  //   StandingOrder: '站序',
  //   stationName: '站名',
  //   arrivalTimeTxt: '到时',
  //   departTimeTxt: '发时',
  //   departDate: '出发日期',
  //   arrivalDate: '到达日期',
  //   hotelHolderKeyWords: '请输入关键字/酒店名等',
  //   HotelRemarks: '订房间请不要超过5间，入住日期不要超过20晚。若需特殊预订请联系我司客服。',
  //   TrainRemarks: '提示：购票时间为早7:30—晚22:30。购票、改签和退票须不晚于开车前30分钟。当天内行程请在10分钟内支付，24小时以外行程请在25分钟内支付。',
  //   NoTrainSearch: '当前时段不提供车次查询服务',
  //   mapTxt: '地图/导航',
  //   detailsOrFacilities: '详情/设施',
  //   noSooner: '无早',
  //   breakfast: '早餐',
  //   breakfastTxt: '含早',
  //   noCancellation: '不可取消',
  //   timeToCancel: '限时取消',
  //   RoomsTxt: '房间数',
  //   hotelUnit: '晚',
  //   checkInTxt: '入住',
  //   checkOutTxt: '离店',
  //   checkInDate: '入住日期',
  //   checkOutDate: '离店日期',
  //   Frequenter: '常客',
  //   Temporary: '临客',
  //   TemporaryInformation: '临客信息',
  //   addFrequenter: '添加常客',
  //   addTemporary: '添加临客',
  //   TravelStandard: '差旅标准',
  //   hightToLow: '从高到低',
  //   lowToHight: '从低到高',
  //   morningToNight: '从早到晚',
  //   nightToMorning: '从晚到早',
  //   starLevelTxt: '星级',
  //   filtrateTxt: '筛选',
  //   timeTxt: '时间',
  //   fromTo: '起',
  //   portion: '份',
  //   contactNumber: '联系电话',
  //   conformToRules: '符合规则',
  //   breakToRules: '违背规则',
  //   unlimited: '不限',
  //   beforeDay: '前一天',
  //   afterDay: '后一天',
  //   adequateTxt: '充足',
  //   Remaining: '仅剩',
  //   taxesTxt: '税费',
  //   BackTorule: '退改规则',
  //   booking: '订',
  //   onlinePay: '在线付',
  //   departTxt: '出发',
  //   arrivalTxt: '到达',
  //   sheet: '张',
  //   NoTicket: '无票',
  //   orderFilltitle: '订单填写',
  //   tripInfosTitle: '出行人信息',
  //   BookingInformation: '预订须知',
  //   tripInfosRemarks: '为了您顺利出行，请务必保证填写项与出游所持证件一致',
  //   addTraveller: '添加旅客',
  //   UserName: '姓名',
  //   contactInfosTitle: '联系人信息',
  //   RemarkInfosTitle: '备注信息',

  //   contacts: '联系人',
  //   Phone: '手机',
  //   Email: '电子邮件',
  //   InstructTitle: '扣款说明',
  //   InstructContent: '会根据您的付款方式进行预授权或扣除房费，如订单不确认将解除预授权或全额退款至您的付款账户。该订单确认后不可被取消修改，若未入住将收取您首日房费，如提前离店将扣除提前离店当天的费用。',
  //   SpecialTipsTitle: '特别提示',
  //   SpecialTipsContent: '该酒店的入住时间为14:00，退房标准结算时间为12:00。如 提前入住或推迟离店，均须酌情加收一定的费用。',
  //   travelInformationTitle: '差旅信息',
  //   CostCenter: '成本中心',
  //   TravelPurpose: '差旅目的',
  //   ProjectCode: '项目代码',
  //   contraryReason: '违背原因',
  //   ViolateTravelRules: '违背差旅规则',
  //   SpecialRequirement: '特殊需求',
  //   SpecialRequirementTips: '特殊需求备注',
  //   specialRequirementContent: '你的特殊要求，我们会尽量协调。如无法满足，我们不会 另行通知，请您见谅。',
  //   otherRequirement: '其他需求',
  //   consentAgreement: '点击提交表示已阅读并同意',
  //   importantTerms: '预订须知和重要条款',
  //   BookingHint: '为支持绿色环保,默认电子合同,若需要签订纸质合同请致电客服。',
  //   CostDetails: '费用明细',
  //   payTotalPrice: '应付总额',
  //   totalPrice: '总额',
  //   roomUnit: '房',
  //   peopleUnit: '人',
  //   details: '明细',
  //   CustomerService: '联系客服',
  //   SubmissionOrPayment: '提交/支付',
  //   frequentlnformationTitle: '旅客信息',
  //   TravellerTitle: '旅客姓名',
  //   EnglishName: '英文姓名',
  //   LastName: '英文姓',
  //   firstName: '英文名',
  //   NameOrIdCardTips: '为了确保顺利出行，请确保出行姓名与证件保持一致。',
  //   CertificateInformatTitle: '证件信息',
  //   ExpireDate: '证件有效期',
  //   otherInfosTitle: '其他信息',
  //   Sex: '性别',
  //   Birthday: '出生日期',
  //   Nationality: '国籍',
  //   optionalCard: '旅客卡（选填）',
  //   reminderInfos: '为了你能顺利出行，请确保旅行结束日期至少比证件有效期早6个月，并确认填写真实、有效的证件号码，订单提交后将无法修改',
  //   addOrEditTraveller: '添加编辑旅客',
  //   AllOrder: '全部订单',
  //   orderStatus: '订单状态',
  //   departTime: '出发时间',
  //   orderDetail: '订单详情',
  //   CancelOrder: '取消订单',
  //   ApprovalRefused: '审批拒绝',
  //   ApproveSucc: '审批通过',
  //   PayNow: '立即支付',
  //   Refund: '退票',
  //   Change: '改签',
  //   SubmitOrder: '提交订单',
  //   PriceDetail: '价格详情',
  //   CheckOrderProgress: '查看订单进度',
  //   flightInformation: '航班信息',
  //   orderNumber: '订单号',
  //   BookingTime: '预订时间',
  //   First: '第',
  //   Journey: '程',
  //   few: '间',
  //   Level: '级',
  //   BackToChangeTips: '最终金额以航司审核为准，如有疑问请拨打客服电话',
  //   pleaseChoose: '请选择',
  //   ThePassengers: '的旅客',
  //   Transfer: '经停',
  //   Flight: '航班',
  //   RefundRoomsDate: '退房入住时间',
  //   TheReason: '的原因',
  //   TheTrain: '的车次',
  //   hour: '小时',
  //   minute: '分钟',
  //   Gym: '健身房',
  //   district: '行政区',
  //   business: '商业区',
  //   ThePassengerInformation: '旅客信息',
  //   NewTrainInformation: '新车次信息',
  //   OriginalTrainInformation: '原车次信息',
  //   NewFlightInformation: '新航班信息',
  //   OriginalFlightInformation: '原航班信息',
  //   NextStep: '下一步',
  //   ChangeDate: '改签日期',
  //   SelectChangeFlight: '请选择改签的航班',
  //   SelectRefundFlight: '请选择退票的航班',
  //   SelectChangeTrain: '请选择改签的旅客',
  //   SelectRefundTrain: '请选择退票的旅客',
  //   SelectRefundHotel: '请选择退票的酒店',
  //   SelectChangeDate: '请选择改签日期',
  //   Department: '部门',
  //   ApprovalStatus: '审批状态',
  //   ConfidentialInformation: '凭证信息',
  //   TradeInformation: '交易信息',
  //   Insurance: '保险',
  //   Home: '首页',
  //   Stroke: '行程',
  //   Me: '我的',
  //   TravelApproval: '差旅审批',
  //   TravelRulesName: '差旅规则名称',
  //   MinimumPriceBase: '最低价格基准',
  //   RealFlightControl: '实时航班管控',
  //   AdvanceBookingTime: '提前预订时间',
  //   ClassLimit: '舱位级别限制',
  //   SeatClassLimit: '座位级别限制',
  //   AgreementAirlinePriority: '协议机票优先',
  //   AgreementHotelPriority: '协议酒店优先',
  //   MaximumAmountConsumption: '消费金额上限',
  //   ApprovalName: '审批名称',
  //   Other: '其他',
  //   FirstClassCity: '一级城市',
  //   SecondaryCity: '二级城市',
  //   ThreeLevelCity: '三级城市',
  //   SeatSelectionService: '选座服务',
  //   Bezel: '窗',
  //   Aisle: '过道',
  //   NewContacts: '新增联系人',
  //   AdditionalInvoiceInformation: '新增/编辑发票信息',
  //   InvoiceInformation: '发票信息',
  //   InvoiceTitle: '发票抬头',
  //   TariffItem: '税号',
  //   SetDefaultContacts: '设置默认联系人',
  //   ConsigneeAddress: '收件地址',
  //   NewCommonAddresses: '新增常用地址',
  //   default: '默',
  //   City: '城市',
  //   Address: '地址',
  //   Postcode: '邮编',
  //   AddCommonAddresses: '新增/编辑常用地址',
  //   DepartureTime: '起飞时间',
  //   Airport: '机场',
  //   ShippingSpace: '舱位',
  //   AirlineCompany: '航空公司',
  //   '150OrLess': '￥150以下',
  //   '150And300': '￥150-300',
  //   '300And450': '￥300-450',
  //   '450And600': '￥450-600',
  //   '600OrMore': '￥600以上',
  //   TwoStarsOrLess: '二星及以下',
  //   ThreeStar: '三星级/舒适',
  //   FourStar: '四星级/高档',
  //   FivesStar: '五星级/豪华',
  //   Apartment: '公寓',
  //   Inn: '客栈',
  //   FamilyInn: '家庭旅馆',
  //   YouthHostel: '青年旅舍',
  //   CoupleHotel: '情侣酒店',
  //   GardenCourtyard: '园林庭院',
  //   SeaView: '海景',
  //   Farmhouse: '农家乐',
  //   HotSpringHotel: '温泉酒店',
  //   GolfHotel: '高尔夫酒店',
  //   Siheyuan: '四合院',
  //   Villa: '别墅',
  //   PartyCooking: '聚会做饭',
  //   BusinessTtravelHome: '商旅之家',
  //   LeisureMood: '休闲情调',
  //   SeeDoctor: "看病就医",
  //   VacationLeisure: "度假休闲",
  //   TrainAndLearn: "培训学习",
  //   GetTogether: "聚会",
  //   HoneymoonTrip: "蜜月出行",
  //   boutiqueHotel: "精品酒店(设计师酒店)",
  //   FreeWifi: "免费wifi",
  //   FreeParking: "免费停车场",
  //   IndoorPool: "室内游泳池",
  //   OutdoorPool: "室外游泳池",
  //   service: "健身房",
  //   BusinessCenter: "商务中心",
  //   MeetingRoom: "会议室",
  //   HotelRestaurant: "酒店餐厅",
  //   MorningCall: "叫醒服务",
  //   LuggageStorage: "行李寄存",
  //   TwinBed: "双床",
  //   BigBed: "大床",
  //   FreePickUpService: "免费接机服务",
  //   Price: '价格',
  //   StarLevel: '星级',
  //   Specialtie: '特色',
  //   Service: '设施服务',
  //   DetailsOrFacilities: '详情/设施',
  //   HotelDetail: '酒店详情',
  //   ModelSelection: '机型选择',
  //   HighSpeedRail: '高铁(G/C)',
  //   MotorCar: '动车(D)',
  //   Ordinary: '普通(Z/T/K)',
  //   DepartureOrArrival: '出发/到达车站',
  //   Service: '服务',
  //   Date: '日期',
  //   Status: '状态',
  //   OldSystem: '请使用PC版查看',
  //   Welcome: '欢迎您',
  //   PleaseLogIn: '请登录',
  //   FlightTips: '低价机票，舒适出行',
  //   HotelTips: '尊享入住，商旅独享',
  //   TrainTips: '一键闪电出票',
  //   TourTips: '精选特价旅游',
  //   Invoice: '发票抬头',
  //   InvoiceType: '发票类型',
  //   Identifier: '识别号',
  //   TicketInquiry: '机票查询',
  //   TrainInquiry: '火车查询',
  //   HotelInquiry: '酒店查询',
  //   ConsumerHotline: "客服电话",
  //   WeChatService: "微信客服",
  //   TravelPolicy: '差旅政策',
  //   EditData: '编辑资料',
  //   RecommendFlight: '推荐航班',
  //   OriginalFlight: '原航班',
  //   More: '更多',
  //   Hidden: '隐藏',
  //   JetFuel: '含机建燃油',
  //   Booking: '预订',
  //   CurrentPosition: '当前位置',
  //   Room: '房间',
  //   SquareMeters: '平米',
  //   CanLive: '可住',
  //   Floor: '楼层',
  //   Layer: '层',
  //   ServiceFee: '服务费',
  //   InsurancePremium: '保险费',
  //   Yuan: '元',
  //   ContactHotel: '联系酒店',
  //   After: '后',
  //   Before: '前',
  //   For: '为',
  //   DueTo: '预订于',
  //   ViolationPolicy: '违背政策',
  //   CompliancePolicy: '符合政策',
  //   BusinessInformation: '商旅信息',
  //   Within: '以内',
  //   RefuseReason: '拒绝原因',
  //   Against: '违背了',
  //   Policy: '的政策',
  //   DetailedReason: '详情原因',
  //   Wait: '等待',
  //   Approval: '审批',
  //   Breach: '违背',
  //   AirlineAuditStandards: '实际以航司审核为准',
  //   ConfirmOrder: '确认订单',
  //   FlightInformation: '航程信息',
  //   Voyage: '航程',
  //   DeparturePlace: '出发地点',
  //   ArrivePlace: '到达到点',
  //   AddVoyage: '添加航程',

  //   PassengersNumbers: '乘客人数',
  //   ShipType: '舱位类型',
  //   PassengersType: '乘客类型',
  //   ShipCompany: '首选航司',
  //   Remarks: '备注',
  //   PackUp: '收起',
  //   Show: '展开',
  //   DocumentType: '证件类型',
  //   CardNo: '证件号码',
  //   InvoiceRole: '发票角色',
  //   BankName: '银行名称',
  //   BankAccount: '银行账号',
  //   RegisteredAddress: '注册地址',
  //   RegisteredPhone: '注册电话',
  //   ChangeReason: '改签原因',
  //   VoucherNumber: '凭证号',
  //   CancelReason: '取消原因',
  //   ChildInfantBooking: '儿童婴儿预订说明',
  //   BookingInformation: '预订信息'






  // },
  // placeholders: {
  //   contacts: '请填写联系人姓名',
  //   Email: '必填，用于接收确认单',
  //   CostCenter: '请选择成本中心',
  //   TravelPurpose: '请选择差旅目的',
  //   ProjectCode: '请填写项目代码',
  //   CauseName: '请选择违背原因',
  //   CauseDetails: '请填写详细违背原因',
  //   searchTraveller: '请输入姓名',
  //   SearchZones: '城市、车站的中文或拼音',
  //   UserName: '与证件姓名一致',
  //   LastName: '如：张飞，填：ZHANG',
  //   firstName: '如：张飞，填：FEI',
  //   CardNo: '所持证件号码',
  //   Phone: '请输入手机号码',
  //   RecipientAddress: '请输入收件人地址',
  //   RecipientPostcode: '请输入收件人邮编',
  //   OriginalPassword: '请输入原密码',
  //   Password: '请输入密码',
  //   NewPassword: '请输入新密码',
  //   AffirmNewPassword: '请确认密码',
  //   CompanyName: '请输入企业名称',
  //   SelectCity: '请选择城市',
  //   Industry: '请输入行业',
  //   Account: '请输入手机号或邮箱',
  //   VerificationCode: '请输入验证码',
  //   DynamicCode: '请输入动态码',
  //   RegisterPhone: '请注册或绑定手机号！',
  //   Invoice: '发票抬头',
  //   InvoiceType: '发票类型',
  //   Identifier: '必填，纳税人识别号',
  //   UserID: '请输入账户',
  //   RefusalCause: '请输入拒绝原因',
  //   CaseInsensitive: '不区分大小写',
  //   MessageAuthenticationCode: '短信验证码',
  //   DeparturePlace: '出发地点',
  //   ArrivePlace: '到达到点',
  //   ContactEmail: '请输入邮箱',
  //   Remarks: '请输入备注',
  //   ShipCompany: '首选航司',
  //   BankName: '银行名称',
  //   BankAccount: '银行账号',
  //   RegisteredAddress: '注册地址',
  //   RegisteredPhone: '注册电话',
  //   TrainDetailReason: '火车详情原因'

  // },
  // system: {
  //   contacts: '联系信息',
  //   HowToCall: '大家该怎么称呼您',
  //   PerfectInformation: '请完善手机号码',
  //   BindingPhone: '绑定手机',
  //   BindingEmail: '绑定邮箱',
  //   AccountAssociated: '账号关联',
  //   UpdatePassword: '修改登录密码',
  //   Language: '语言',
  //   Chinese: '中',
  //   English: '英',
  //   ExitLogin: '退出登录',
  //   WeChat: '微信',
  //   ImmediatelyBinding: '立即绑定',
  //   AccountAssociated: '账户关联',
  //   Password: '密码',
  //   OriginalPassword: '原密码',
  //   NewPassword: '新密码',
  //   AffirmNewPassword: '确认密码',
  //   ChangePassword: '修改密码',
  //   EditPersonalInformation: '编辑个人资料',
  //   CompanyName: '企业名称',
  //   Industry: '行业',
  //   Account: '账户',
  //   VerificationCode: '验证码',
  //   DynamicCode: '动态码',
  //   RegisterNow: '立即注册',
  //   Register: '注册',
  //   UserRegister: '个人注册',
  //   CompanyRegister: '企业注册',
  //   ServiceAgreement: '同意《力程旅行网服务协议》',
  //   SendDynamicCode: '发送动态码',
  //   Sent: '已发送',
  //   LoginTxt: '登录',
  //   DynamicPasswordLogin: '动态密码登录',
  //   ForgetPassword: '忘记密码',
  //   Integral: '积分',
  //   AllOrders: '全部订单',
  //   Obligation: '待付款',
  //   NotToTravel: '未出行',
  //   ToApproval: '待审批',
  //   TicketInformation: '票证信息',
  //   OrderInformation: '订单信息',
  //   OrderID: '订单编号',
  //   TradeID: '交易编号',
  //   TradeAmount: '订单总金额',
  //   CollectingCompany: '收款公司',
  //   PaymentWays: '支付方式',
  //   Payment: '支付',
  //   ThePassengerInformation: '旅客信息',
  //   PassWordLogin: '密码登录',
  //   CodeLogin: '验证码登录',
  //   Notice: '通知',
  //   RecentOrders: '近期订单',
  //   Reserved: '待订妥',
  //   CustomerService: '客服',
  //   Sell: '销售',

  //   ContactUs: '联系我们',

  //   Call: '呼叫',
  //   ServiceDept: '客服部',
  //   AllOrders: '所有订单',
  //   MyOrder: '我的订单',
  //   ApprovalDispose: '审批处理',
  //   RetrievePwd: '便于登录或找回密码',
  //   ElectronicBills: '便于接收电子账单',
  //   ApprovalAccredit: '审批授权',
  //   AboutUs: '关于我们',
  //   TestGetCode: '获取验证码',
  //   PhoneHint: '您可以通过有效的绑定手机重置密码。',
  //   EmailHint: '您可以通过有效的绑定邮箱重置密码。',
  //   LoginPassword: '登录密码',
  //   ResetPassword: '重置密码',
  //   EnterAccount: '输入账号',
  //   PhoneVerification: '手机验证',
  //   EmailVerification: '邮箱验证',
  //   SetBinding: '设置绑定',
  //   Input: '输入',
  //   Effective: '有效的',
  //   Verify: '验证',
  //   NextStep: '下一步',
  //   RemarkString: '退改签时限',
  //   RefundFee: '退票费',
  //   Cabinfee: '同舱改期费',
  //   ReimburseInfo: '报销信息',
  //   BaggageAllowance: '行李额',
  //   BackChangeRemark: '以上成人退改签规则及费用标准，仅供参考，实际需以航司为准.',
  //   PartRoute: '部分航线',
  //   PartHotel: '部分酒店',
  //   IsSaveCustomers: '是否保存常客',

  //   EmployeeRights: '员工权限',
  //   DateGranted: '授予日期',

  //   ExpiryDate: '过期日期',
  //   AddApproval: '添加/修改审批',
  //   AddApprovals: '添加审批',
  //   DownloadInstall: '下载安装',
  //   TopRightCorner: '请点击右上角',
  //   BrowserOpen: '选择"浏览器中打开"',
  //   CannotDownloaded: '微信/QQ内无法下载应用',
  //   CompanyProfile: '公司概况',
  //   CompanyProfileContent: '上海力程官网(www.lichengtrip.net)隶属于上海力程票务有限公司，公司总部设在中国上海，总部办公地点位于上海市长宁区新东纺国际商务中心，紧临静安寺曹家渡等商务中心地段，内设呼叫中心、总经办、财务部、票务结算部、国际部、国内同行部、客户服务部、培训部、商务部、运营中心等相应部门。是上海销售范围较广、服务规模较大、综合实力较强的大型民航服务企业。',

  //   FutureProspects: '未来前景',
  //   FutureProspectsContent: '在互联网技术迅猛发展的21世纪，上海力程联合科研单位研发的商旅分销系统，用具有独立知识产权的先进技术，以方便快捷的流线型工程服务于天下民众生活的方方面面，让每一个生活在网络社会的普通百姓，都有机会成为网络经济大潮的弄潮儿。使他们在分分秒秒的网络生活体验中，感受到中华民族优秀传统文化和现代民主生活方式的完美融合，感受到实实在在的人文关爱和物质生活的不断丰富与提升，为推动网络社会健康、和谐、稳定发展，奉献出力程人的全部热情和智慧!2016年是力程迎来更高发展的时刻，以创新和进取为动力，进一步加快发展速度，提升发展品质，以国际、国内机票销售为主体、度假预订并举，实施全面发展战略，着力推进信息化、构建信息平台。',
  //   ManagementTeam: '紧密精进的管理团队',
  //   ManagementTeamContent: '上海力程的管理团队在资源合作、管理技能、业务经验上的完美组合，以及团队间紧密贴切的合作保证了公司迅速稳健的发展。我们的高层管理团队集合了国际IT业、旅游业及金融业多年业务运作与管理的经验；中层管理团队汇集了中国IT业、航空代理业及旅游业的，保证了服务规模化和资源规模化的管理方针。',
  //   TechnicalService: '技术领先与服务',
  //   TechnicalServiceContent: '力程一直将技术创新视为企业的活力源泉，在提升研发能力方面不遗余力。力程建立了一整套现代化服务系统，以创新和进取为动力，进一步加快发展速度，提升发展品质，以国际、国内机票销售为主体、酒店预订、度假预订并举，实施全面发展战略，着力推进信息化、构建信息平台。',
  //   AboutUs:'联系我们',
  //   AboutUsContent:'电话：400-088-8020',

  // },
  // share: {
  //   hot: '热门',
  //   calendarDataTitle: '选择日期',
  //   calendarDataExplain: '查询日期为出发日期',
  //   cancelTxt: "取消",
  //   confirmTxt: "确定",
  //   pullUpLoadMoreTxt: '加载更多',
  //   pullUpLoadNoMoreTxt: '没有更多',
  //   RefreshTheSuccess: '刷新成功',
  //   Save: '保存',
  //   Add: '添加',
  //   QueryBtn: '查询',
  //   SubmitBtn: '提交',
  //   AmendBtn: '修改',
  //   FinishBtn: '完成',
  //   fail: {
  //     selectTraveller: '请选择旅客！',
  //     minPrice: '您选择不是推荐航班或舱位，确定要继续预订？',
  //     CostCenter: '请输入成本中心！',
  //     TravelPurpose: '请输入差旅目的！',
  //     EnglishName: '该乘客没有英文名称！',
  //     RefundJourney: '请选择您需要退票的行程！',
  //     RefundReason: '请选择您需要退票的原因！',
  //     RefundTraveller: '请选择您需要退票的旅客！',
  //     ChangeJourney: '请选择您需要改签的行程！',
  //     ChangeTraveller: '请选择您需要改签的旅客！',
  //     ChooseAnotherFlight: '请选择其他航司的航班！',
  //     TheCorrectName: '请输入正确的姓和名！',
  //     UsreNameRepetition: '乘客名不能重复！',
  //     RegisterPhone: '请注册或绑定手机号！',
  //     VerificationCode: '请输入验证码',
  //     DynamicCode: '请输入动态码',
  //     PassengerSurname: '请输入旅客姓',
  //     PassengerName: '请输入旅客名',
  //     RefusalCause: '请填写拒绝原因！',
  //     PhoneBinding: '绑定的手机号不能空',
  //     EmailBinding: '绑定的邮箱不能空',
  //     Phone: '请输入正确的手机号',
  //     Email: '请输入正确的邮箱',
  //     VerificationTime: '每隔60s才能获取一次验证码',
  //     Account: '请输入账号',
  //     AccountEmpty: '账号不能为空',
  //     PasswordEmpty: '密码不能为空',
  //     PassengersNumbers: '旅客数量已上限,请联系客服',
  //     ManyPeople: '人数过多,请联系客服进行团购',
  //     ChangeReason: '改签原因不能为空',
  //     SeatNumbers: '乘客人数超过选择座位数',
  //     SelectSeat: '请为已选择的旅客选择座位'
  //   },
  //   succ: {
  //     SaveSucc: '保存成功！',
  //     CancelSucc: '取消成功！',
  //     ApprovalRefused: '审批拒绝！',
  //     ApproveSucc: '审批通过！',
  //     RefundSucc: '退票申请提交成功',
  //     ChangeSucc: '改签申请提交成功！',
  //     RegisteredSucc: '注册成功！',
  //     LoginSucc: '登陆成功！',
  //     ChangePasswordSucc: '密码修改成功',
  //     VerificationSucc: '验证码发送成功',
  //     AddSucc: '添加成功',
  //     ModifySucc: '修改成功',
  //     DeleteSucc: '删除成功',
  //   },
  //   confirm: {
  //     YesOrNoDelect: '是否确认删除',
  //     CreateOrder: '订单创建成功，欢迎您随时在订单详细中关注订单进度',
  //     ThankRemarks: '感谢您长期以来对力程商旅的信任与支持，为了更好提升用户差旅体验，力程商旅2018年10月30日上午9点起正式上线力程商旅2.0系统。用户可通过App Store自动更新, 安卓系统请联系本公司客服咨询，紧急联络电话15901610043。谢谢！'
  //   },
  //   loading: {
  //     load: '努力加载中。。。',
  //     creatOrder: '订单创建中。。。',
  //     PriceCalculation: '价格计算中...'
  //   },

  // },
  // Categorys: {
  //   Young: '成人',
  //   Enfant: '儿童',
  //   Infant: '婴儿',
  //   economyClass: '经济舱',
  //   buissenesClass: '商务舱',
  //   firstClass: '头等舱',
  //   OnBusiness: '因公',
  //   OnPersonal: '因私',
  //   FlightService: '机票',
  //   HotelService: '酒店',
  //   TourService: '旅游',
  //   TrainService: '火车',
  //   SingleVoyage: '单程',
  //   RoundVoyage: '往返',
  //   WaitBooking: '待预订',
  //   WaitConfirm: '待确认',
  //   WaitPayment: '待支付',
  //   WaitDispose: '待处理',
  //   Finished: '已完成',
  //   Canceled: '已取消',
  //   Rejected: '已退回',
  //   Cannot: '暂不能',
  //   WaitApprove: '待审批',
  //   Discrete: '已拆分',
  //   WaitSubmit: '待提交',
  //   WaitRefund: '待退款',
  //   Male: '男',
  //   Female: '女',
  //   IDCard: "身份证",
  //   PassportCard: "护照",
  //   StudentCard: "学生证",
  //   OfficerCard: "军官证",
  //   HKMpermit: "港澳通行证",
  //   TaiWpermit: "台湾通行证",
  //   OtherCard: "其它",
  //   Company: '公司',
  //   User: '用户',
  //   HotelFare: '房费',
  //   TicketFare: '票面',
  //   MobileAuth: '手机账号',
  //   EmailAuth: '邮箱账号',
  //   AccountAuth: '账号密码',
  //   WeixinAuth: '微信授权',
  //   DynamicAuth: '动态密码',
  //   MessageNotify: '短信通知',
  //   MailNotify: '邮件通知',
  //   WechatNotify: '微信通知',
  //   AppNotify: 'App通知',
  //   Normal: '普通',
  //   OverseasStudent:'学生',
  //   Worker:'劳务',
  //   Immigrant:'新移民',
  // },
  // RegExp: {
  //   AccountReg: {
  //     isEmpty: '账户不能空',
  //     isFormat: '账户格式不正确'
  //   },
  //   PwdReg: {
  //     isEmpty: '密码不能空',
  //     isFormat: '密码格式不正确'
  //   },
  //   ConfigPwd: {
  //     isEmpty: '密码不能空',
  //     isFormat: '密码不一致'
  //   },
  //   VerificationCodeReg: {
  //     isEmpty: '验证码不能空',
  //   },
  //   DynamicCodeReg: {
  //     isEmpty: '动态码不能空',
  //   },
  //   ProtocolReg: {
  //     isFlag: '必须遵守协议'
  //   }
  // }
  mall: {
    allprice: '全价',
    discount: '折',
    GivenName: '英文名',
    Surname: '英文姓',
    selectedseat: '已选座',
    noselectseat: '未选座',
    takeOff: '起飞',
    FillInfo: '填写须知',
    ExpiryDate: '有效期',
    StartTime: '开始时间',
    EndTime: '结束时间',
    ToProcessDate: '去程日期',
    backTracking: '返程日期',
    sharing: '共享',
    AirplaneModelTxt: '机型',
    ticketfeeFloat: '此价格不含机建燃油税费',
    peopleTypeExplain: '儿童婴儿预订说明',
    bookingTicketExplain: '如需预订儿童/婴儿票，请联系本公司客服。',
    onlySeeDirect: '仅看直飞',
    hiddenSharedFlight: '隐藏共享航班',
    ActualCarrier: '实际承运',
    stayTxt: '停留',
    turnTxt: '转',
    priceRemarks: '以下费用均为“1成人或1儿童或1婴儿”的人均价',
    AgreementPrice: '商务推荐',
    tax: '税',
    trainHolderKeyWords: '国内火车票',
    bookingRemarks: '一次最多只能预订5位乘客',
    beginTxt: '始',
    passTxt: '过',
    endTxt: '终',
    StandingOrder: '站序',
    stationName: '站名',
    arrivalTimeTxt: '到时',
    departTimeTxt: '发时',
    departDate: '出发日期',
    arrivalDate: '到达日期',
    hotelHolderKeyWords: '请输入关键字/酒店名等',
    HotelRemarks: '订房间请不要超过5间，入住日期不要超过20晚。若需特殊预订请联系我司客服。',
    TrainRemarks: '提示：购票时间为早7:30—晚22:30。购票、改签和退票须不晚于开车前30分钟。当天内行程请在10分钟内支付，24小时以外行程请在25分钟内支付。',
    NoTrainSearch: '当前时段不提供车次查询服务',
    mapTxt: '地图/导航',
    detailsOrFacilities: '详情/设施',
    noSooner: '无早',
    breakfast: '早餐',
    breakfastTxt: '含早',
    noCancellation: '不可取消',
    timeToCancel: '限时取消',
    RoomsTxt: '房间数',
    hotelUnit: '晚',
    checkInTxt: '入住',
    checkOutTxt: '离店',
    checkInDate: '入住日期',
    checkOutDate: '离店日期',
    Frequenter: '常客',
    Temporary: '临客',
    TemporaryInformation: '临客信息',
    addFrequenter: '添加常客',
    addTemporary: '添加临客',
    TravelStandard: '差旅标准',
    hightToLow: '从高到低',
    lowToHight: '从低到高',
    morningToNight: '从早到晚',
    nightToMorning: '从晚到早',
    starLevelTxt: '星级',
    filtrateTxt: '筛选',
    timeTxt: '时间',
    fromTo: '起',
    portion: '份',
    contactNumber: '联系电话',
    conformToRules: '符合规则',
    breakToRules: '违背规则',
    unlimited: '不限',
    beforeDay: '前一天',
    afterDay: '后一天',
    adequateTxt: '充足',
    Remaining: '仅剩',
    taxesTxt: '税费',
    BackTorule: '退改规则',
    trainamendrule:'对开车前15天(不含)以上退票的，不收取退票费。票面乘车站开车前48小时以上的，退票时收取票价5%的退票费;开车前24小时以上、不足48小时的，退票时收取票价10%的退票费;开车前不足24小时的，退票时收取票价20%退票费。',
    booking: '订',
    onlinePay: '在线付',
    departTxt: '出发',
    arrivalTxt: '到达',
    sheet: '张',
    NoTicket: '无票',
    orderFilltitle: '订单填写',
    tripInfosTitle: '出行人信息',
    BookingInformation: '预订须知',
    tripInfosRemarks: '为了您顺利出行，请务必保证填写项与出游所持证件一致',
    addTraveller: '添加旅客',
    UserName: '姓名',
    contactInfosTitle: '联系人信息',
    RemarkInfosTitle: '备注信息',
    contacts: '联系人',
    Phone: '手机',
    Email: '电子邮件',
    InstructTitle: '扣款说明',
    InstructContent: '会根据您的付款方式进行预授权或扣除房费，如订单不确认将解除预授权或全额退款至您的付款账户。该订单确认后不可被取消修改，若未入住将收取您首日房费，如提前离店将扣除提前离店当天的费用。',
    SpecialTipsTitle: '特别提示',
    SpecialTipsContent: '该酒店的入住时间为14:00，退房标准结算时间为12:00。如 提前入住或推迟离店，均须酌情加收一定的费用。',
    travelInformationTitle: '差旅信息',
    CostCenter: '成本中心',
    TravelPurpose: '差旅目的',
    ProjectCode: '项目代码',
    contraryReason: '违背原因',
    ViolateTravelRules: '违背差旅规则',
    SpecialRequirement: '特殊需求',
    SpecialRequirementTips: '特殊需求备注',
    specialRequirementContent: '你的特殊要求，我们会尽量协调。如无法满足，我们不会 另行通知，请您见谅。',
    otherRequirement: '其他需求',
    consentAgreement: '点击提交表示已阅读并同意',
    importantTerms: '预订须知和重要条款',
    BookingHint: '为支持绿色环保,默认电子合同,若需要签订纸质合同请致电客服。',
    CostDetails: '费用明细',
    payTotalPrice: '应付总额',
    totalPrice: '总额',
    roomUnit: '房',
    nightUnit: '夜',
    peopleUnit: '人',
    details: '明细',
    CustomerService: '联系客服',
    SubmissionOrPayment: '提交/支付',
    frequentlnformationTitle: '旅客信息',
    TravellerTitle: '旅客姓名',
    EnglishName: '英文姓名',
    LastName: '英文姓',
    firstName: '英文名',
    NameOrIdCardTips: '为了确保顺利出行，请确保出行姓名与证件保持一致。',
    CertificateInformatTitle: '证件信息',
    ExpireDate: '证件有效期',
    otherInfosTitle: '其他信息',
    Sex: '性别',
    Birthday: '出生日期',
    Nationality: '国籍',
    optionalCard: '旅客卡（选填）',
    reminderInfos: '为了你能顺利出行，请确保旅行结束日期至少比证件有效期早6个月，并确认填写真实、有效的证件号码，订单提交后将无法修改',
    addOrEditTraveller: '添加编辑旅客',
    AllOrder: '全部订单',
    orderStatus: '订单状态',
    departTime: '出发时间',
    orderDetail: '订单详情',
    CancelOrder: '取消订单', 
    CancelRefund:'取消退票',
    CancelChange:'取消改签',
    ApprovalRefused: '审批拒绝',
    ApproveSucc: '审批通过',
    PayNow: '立即支付',
    Refund: '退票',
    RefundHotel:'退房',
    RefundGroup:'退团',
    Change: '改签',
    SubmitOrder: '提交订单',
    PriceDetail: '价格详情',
    CheckOrderProgress: '查看订单进度',
    flightInformation: '航班信息',
    orderNumber: '订单号',
    BookingTime: '预订时间',
    First: '第',
    Journey: '程',
    few: '间',
    Level: '级',
    BackToChangeTips: '最终金额以审核为准，如有疑问请拨打客服电话',
    pleaseChoose: '请选择',
    ThePassengers: '的旅客',
    Transfer: '经停',
    Flight: '航班',
    RefundRoomsDate: '退房入住时间',
    TheReason: '的原因',
    TheTrain: '的车次',
    hour: '小时',
    minute: '分钟',
    Gym: '健身房',
    district: '行政区',
    business: '商业区',
    ThePassengerInformation: '旅客信息',
    NewTrainInformation: '新车次信息',
    OriginalTrainInformation: '原车次信息',
    NewFlightInformation: '新航班信息',
    OriginalFlightInformation: '原航班信息',
    NextStep: '下一步',
    ChangeDate: '改签日期',
    SelectChangeFlight: '请选择改签的航班',
    SelectRefundFlight: '请选择退票的航班',
    SelectChangeTrain: '请选择改签的旅客',
    SelectRefundTrain: '请选择退票的旅客',
    SelectRefundHotel: '请选择退房的酒店',
    SelectChangeDate: '请选择改签日期',
    Department: '部门',
    ApprovalStatus: '审批状态',
    ConfidentialInformation: '凭证信息',
    TradeInformation: '交易信息',
    Insurance: '保险',
    Home: '首页',
    Stroke: '行程',
    Me: '我的',
    TravelApproval: '差旅审批',
    TravelRulesName: '差旅规则名称',
    MinimumPriceBase: '最低价格基准',
    RealFlightControl: '实时航班管控',
    AdvanceBookingTime: '提前预订时间',
    ClassLimit: '舱位级别限制',
    SeatClassLimit: '座位级别限制',
    AgreementAirlinePriority: '协议机票优先',
    AgreementHotelPriority: '协议酒店优先',
    MaximumAmountConsumption: '消费金额上限',
    ApprovalName: '审批名称',
    Other: '其他',
    FirstClassCity: '一级城市',
    SecondaryCity: '二级城市',
    ThreeLevelCity: '三级城市',
    SeatSelectionService: '选座服务',
    Bezel: '窗',
    Aisle: '过道',
    NewContacts: '新增联系人',
    AdditionalInvoiceInformation: '新增/编辑发票信息',
    InvoiceInformation: '发票信息',
    InvoiceTitle: '发票抬头',
    TariffItem: '税号',
    SetDefaultContacts: '设置默认联系人',
    ConsigneeAddress: '收件地址',
    NewCommonAddresses: '新增常用地址',
    default: '默',
    City: '城市',
    Address: '地址',
    Postcode: '邮编',
    AddCommonAddresses: '新增/编辑常用地址',
    DepartureTime: '起飞时间',
    Airport: '机场',
    ShippingSpace: '舱位',
    AirlineCompany: '航空公司',
    '150OrLess': '￥150以下',
    '150And300': '￥150-300',
    '300And450': '￥300-450',
    '450And600': '￥450-600',
    '600OrMore': '￥600以上',
    TwoStarsOrLess: '二星及以下',
    ThreeStar: '三星级/舒适',
    FourStar: '四星级/高档',
    FivesStar: '五星级/豪华',
    Apartment: '公寓',
    Inn: '客栈',
    FamilyInn: '家庭旅馆',
    YouthHostel: '青年旅舍',
    CoupleHotel: '情侣酒店',
    GardenCourtyard: '园林庭院',
    SeaView: '海景',
    Farmhouse: '农家乐',
    HotSpringHotel: '温泉酒店',
    GolfHotel: '高尔夫酒店',
    Siheyuan: '四合院',
    Villa: '别墅',
    PartyCooking: '聚会做饭',
    BusinessTtravelHome: '商旅之家',
    LeisureMood: '休闲情调',
    SeeDoctor: "看病就医",
    VacationLeisure: "度假休闲",
    TrainAndLearn: "培训学习",
    GetTogether: "聚会",
    HoneymoonTrip: "蜜月出行",
    boutiqueHotel: "精品酒店(设计师酒店)",
    FreeWifi: "免费wifi",
    FreeParking: "免费停车场",
    IndoorPool: "室内游泳池",
    OutdoorPool: "室外游泳池",
    service: "健身房",
    BusinessCenter: "商务中心",
    MeetingRoom: "会议室",
    HotelRestaurant: "酒店餐厅",
    MorningCall: "叫醒服务",
    LuggageStorage: "行李寄存",
    TwinBed: "双床",
    BigBed: "大床",
    FreePickUpService: "免费接机服务",
    Price: '价格',
    StarLevel: '星级',
    Specialtie: '特色',
    Service: '设施服务',
    DetailsOrFacilities: '详情/设施',
    HotelDetail: '酒店详情',
    ModelSelection: '机型选择',
    HighSpeedRail: '高铁(G/C)',
    MotorCar: '动车(D)',
    Ordinary: '普通(Z/T/K)',
    DepartureOrArrival: '出发/到达车站',
    Service: '服务',
    Date: '日期',
    Status: '状态',
    OldSystem: '请使用PC版查看',
    Welcome: '欢迎您',
    PleaseLogIn: '请登录',
    FlightTips: '低价机票，舒适出行',
    HotelTips: '尊享入住，商旅独享',
    TrainTips: '一键闪电出票',
    TourTips: '精选特价旅游',
    Invoice: '发票抬头',
    InvoiceType: '发票类型',
    Identifier: '识别号',
    TicketInquiry: '机票查询',
    TrainInquiry: '火车查询',
    HotelInquiry: '酒店查询',
    ConsumerHotline: "客服电话",
    WeChatService: "微信客服",
    TravelPolicy: '差旅政策',
    EditData: '编辑资料',
    RecommendFlight: '推荐航班',
    OriginalFlight: '原航班',
    More: '更多',
    MoreInfo: '更多信息',
    Hidden: '隐藏',
    JetFuel: '含机建燃油',
    Booking: '预订',
    CurrentPosition: '当前位置',
    Room: '房间',
    SquareMeters: '平米',
    CanLive: '可住',
    Floor: '楼层',
    Layer: '层',
    ServiceFee: '服务费',
    InsurancePremium: '保险费',
    Yuan: '元',
    ContactHotel: '联系酒店',
    After: '后',
    Before: '前',
    For: '为',
    DueTo: '预订于',
    ViolationPolicy: '违背政策',
    CompliancePolicy: '符合政策',
    BusinessInformation: '商旅信息',
    Within: '以内',
    RefuseReason: '审批备注',
    Against: '违背了',
    Policy: '的政策',
    DetailedReason: '详情原因',
    Wait: '等待',
    Approval: '审批',
    Breach: '违背',
    AirlineAuditStandards: '以航空公司最新规定为准，可咨询客服电话',
    ConfirmOrder: '确认订单',
    FlightInformation: '航程信息',
    Voyage: '航程',
    DeparturePlace: '出发地点',
    ArrivePlace: '到达到点',
    AddVoyage: '添加航程',
    PassengersNumbers: '乘客人数',
    ShipType: '舱位类型',
    PassengersType: '乘客类型',
    ShipCompany: '首选航司',
    Remarks: '备注',
    PackUp: '收起',
    Show: '展开',
    DocumentType: '证件类型',
    CardNo: '证件号码',
    InvoiceRole: '发票角色',
    BankName: '银行名称',
    BankAccount: '银行账号',
    RegisteredAddress: '注册地址',
    RegisteredPhone: '注册电话',
    ChangeReason: '改签原因',
    VoucherNumber: '凭证号',
    CancelReason: '取消原因',
    ChildInfantBooking: '儿童婴儿预订说明',
    BookingInformation: '预订信息',










    boyin: '波音',
    kongke: '空客',
    AppropriationBudget: '经费预算',
    Attendance: '参会人数',
    HostPlace: '举办地点',
    Destination: '目的地',
    ParticipantsNumber: '参加人数',
    ActivityBudget: '活动预算',
    AmountPaid: '需要支付金额',
    ConfirmPayment: '确认支付',
    Pay: '付',
    PriceTxt: '价'


  },
  placeholders: {
    contacts: '请填写联系人姓名',
    Email: '用于接收确认单',
    CostCenter: '请选择成本中心',
    TravelPurpose: '请选择差旅目的',
    ProjectCode: '请填写项目代码',
    CauseName: '请选择违背原因',
    CauseDetails: '请填写详细违背原因',
    searchTraveller: '请输入姓名',
    SearchZones: '城市、车站的中文或拼音',
    UserName: '与证件姓名一致',
    LastName: '如：张飞，填：ZHANG',
    firstName: '如：张飞，填：FEI',
    CardNo: '所持证件号码',
    Phone: '请输入手机号码',
    RecipientAddress: '请输入收件人地址',
    RecipientPostcode: '请输入收件人邮编',
    OriginalPassword: '请输入原密码',
    Password: '请输入密码',
    NewPassword: '请输入新密码',
    AffirmNewPassword: '请确认密码',
    CompanyName: '请输入企业名称',
    SelectCity: '请选择城市',
    Industry: '请输入行业',
    Account: '请输入手机号或邮箱',
    VerificationCode: '请输入验证码',
    DynamicCode: '请输入动态码',
    RegisterPhone: '请注册或绑定手机号！',
    Invoice: '发票抬头',
    InvoiceType: '发票类型',
    Identifier: '必填，纳税人识别号',
    UserID: '请输入账户',
    RefusalCause: '请输入拒绝原因',
    CaseInsensitive: '不区分大小写',
    MessageAuthenticationCode: '短信验证码',
    DeparturePlace: '出发地点',
    ArrivePlace: '到达到点',
    ContactEmail: '请输入邮箱',
    Remarks: '请输入备注',
    ShipCompany: '首选航司',
    BankName: '银行名称',
    BankAccount: '银行账号',
    RegisteredAddress: '注册地址',
    RegisteredPhone: '注册电话',
    TrainDetailReason: '火车详情原因',


    PeopleNumber: '请输入人数',
    AppropriationBudget: '请输入预算经费',
    ContactNumber: '请输入联系电话',
    ContactRemarks: '告诉我们您最方便的联系时间及方式，让我们在最恰当的时间回复您。'
  },
  system: {
    EmailNotification:'邮件通知',
    servicePhone: '400-088-8020',
    Company: '力程商旅',
    Name: '力程商旅',
    contacts: '联系信息',
    HowToCall: '大家该怎么称呼您',
    PerfectInformation: '请完善手机号码',
    BindingPhone: '绑定手机',
    BindingEmail: '绑定邮箱',
    AccountAssociated: '账号关联',
    UpdatePassword: '修改登录密码',
    Language: '语言',
    Chinese: '中',
    English: '英',
    ExitLogin: '退出登录',
    WeChat: '微信',
    ImmediatelyBinding: '立即绑定',
    Password: '密码',
    OriginalPassword: '原密码',
    NewPassword: '新密码',
    AffirmNewPassword: '确认密码',
    ChangePassword: '修改密码',
    EditPersonalInformation: '编辑个人资料',
    CompanyName: '企业名称',
    Industry: '行业',
    Account: '账户',
    VerificationCode: '验证码',
    DynamicCode: '动态码',
    RegisterNow: '立即注册',
    Register: '注册',
    UserRegister: '个人注册',
    CompanyRegister: '企业注册',
    ServiceAgreement: '同意《力程旅行网服务协议》',
    SendDynamicCode: '发送动态码',
    Sent: '已发送',
    LoginTxt: '登录',
    DynamicPasswordLogin: '动态密码登录',
    ForgetPassword: '忘记密码',
    Integral: '积分',
    AllOrders: '全部订单',
    Obligation: '待付款',
    NotToTravel: '未出行',
    ToApproval: '待审批',
    TicketInformation: '票证信息',
    OrderInformation: '订单信息',
    OrderID: '订单编号',
    TradeID: '交易编号',
    TradeAmount: '订单总金额',
    CollectingCompany: '收款公司',
    PaymentWays: '支付方式',
    Payment: '支付',
    ThePassengerInformation: '旅客信息',
    PassWordLogin: '密码登录',
    CodeLogin: '验证码登录',
    Notice: '通知',
    RecentOrders: '近期行程',
    Reserved: '待订妥',
    CustomerService: '客服',
    Sell: '销售',
    ContactUs: '联系我们',
    Call: '呼叫',
    ServiceDept: '客服部',
    MyOrder: '我的订单',
    ApprovalDispose: '审批处理',
    RetrievePwd: '便于登录或找回密码',
    ElectronicBills: '便于接收电子账单',
    ApprovalAccredit: '审批授权',
    AboutUs: '关于我们',
    TestGetCode: '获取验证码',
    PhoneHint: '您可以通过有效的绑定手机重置密码。',
    EmailHint: '您可以通过有效的绑定邮箱重置密码。',
    LoginPassword: '登录密码',
    ResetPassword: '重置密码',
    EnterAccount: '输入账号',
    PhoneVerification: '手机验证',
    EmailVerification: '邮箱验证',
    SetBinding: '设置绑定',
    Input: '输入',
    Effective: '有效的',
    Verify: '验证',
    NextStep: '下一步',
    RemarkString: '退改签时限',
    RefundFee: '退票费',
    Cabinfee: '同舱改期费',
    ReimburseInfo: '报销信息',
    BaggageAllowance: '行李额',
    BackChangeRemark: '以上成人退改签规则及费用标准，仅供参考，实际需以航司为准.',
    PartRoute: '部分航线',
    PartHotel: '部分酒店',
    IsSaveCustomers: '是否保存常客',
    EmployeeRights: '员工权限',
    DateGranted: '授予日期',
    ExpiryDate: '过期日期',
    AddApproval: '添加/修改审批',
    AddApprovals: '添加审批',
    DownloadInstall: '下载安装',
    TopRightCorner: '请点击右上角',
    BrowserOpen: '选择"浏览器中打开"',
    CannotDownloaded: '微信/QQ内无法下载应用',
    CompanyProfile: '公司概况',
    CompanyProfileContent: '上海力程官网(www.lichengtrip.net)隶属于上海力程票务有限公司，公司总部设在中国上海，总部办公地点位于上海市长宁区新东纺国际商务中心，紧临静安寺曹家渡等商务中心地段，内设呼叫中心、总经办、财务部、票务结算部、国际部、国内同行部、客户服务部、培训部、商务部、运营中心等相应部门。是上海销售范围较广、服务规模较大、综合实力较强的大型民航服务企业。',
    FutureProspects: '未来前景',
    FutureProspectsContent: '在互联网技术迅猛发展的21世纪，上海力程联合科研单位研发的商旅分销系统，用具有独立知识产权的先进技术，以方便快捷的流线型工程服务于天下民众生活的方方面面，让每一个生活在网络社会的普通百姓，都有机会成为网络经济大潮的弄潮儿。使他们在分分秒秒的网络生活体验中，感受到中华民族优秀传统文化和现代民主生活方式的完美融合，感受到实实在在的人文关爱和物质生活的不断丰富与提升，为推动网络社会健康、和谐、稳定发展，奉献出力程人的全部热情和智慧!2016年是力程迎来更高发展的时刻，以创新和进取为动力，进一步加快发展速度，提升发展品质，以国际、国内机票销售为主体、度假预订并举，实施全面发展战略，着力推进信息化、构建信息平台。',
    ManagementTeam: '紧密精进的管理团队',
    ManagementTeamContent: '上海力程的管理团队在资源合作、管理技能、业务经验上的完美组合，以及团队间紧密贴切的合作保证了公司迅速稳健的发展。我们的高层管理团队集合了国际IT业、旅游业及金融业多年业务运作与管理的经验；中层管理团队汇集了中国IT业、航空代理业及旅游业的，保证了服务规模化和资源规模化的管理方针。',
    TechnicalService: '技术领先与服务',
    TechnicalServiceContent: '力程一直将技术创新视为企业的活力源泉，在提升研发能力方面不遗余力。力程建立了一整套现代化服务系统，以创新和进取为动力，进一步加快发展速度，提升发展品质，以国际、国内机票销售为主体、酒店预订、度假预订并举，实施全面发展战略，着力推进信息化、构建信息平台。',
    AboutUsContent: '电话：400-088-8020',
  },
  share: {
    hot: '热门',
    calendarDataTitle: '选择日期',
    calendarDataExplain: '查询日期为出发日期',
    cancelTxt: "取消",
    confirmTxt: "确定",
    pullUpLoadMoreTxt: '加载更多',
    pullUpLoadNoMoreTxt: '没有更多',
    RefreshTheSuccess: '刷新成功',
    Save: '保存',
    Add: '添加',
    QueryBtn: '查询',
    SubmitBtn: '提交',
    AmendBtn: '修改',
    FinishBtn: '完成',
    fail: {
      CancelOrder:'请选择取消订单',
      RefundOrder:'请选择取消退票订单',   
      selectTraveller: '请选择旅客！',
      minPrice: '您选择不是推荐航班或舱位，确定要继续预订？',
      CostCenter: '请输入成本中心！',
      TravelPurpose: '请输入差旅目的！',
      EnglishName: '该乘客没有英文名称！',
      RefundJourney: '请选择您需要退票的行程！',
      RefundReason: '请选择您需要退票的原因！',
      RefundTraveller: '请选择您需要退票的旅客！',
      ChangeJourney: '请选择您需要改签的行程！',
      ChangeTraveller: '请选择您需要改签的旅客！',
      ChooseAnotherFlight: '请选择其他航司的航班！',
      TheCorrectName: '请输入正确的姓和名！',
      UsreNameRepetition: '乘客名不能重复！',
      RegisterPhone: '请注册或绑定手机号！',
      VerificationCode: '请输入验证码',
      DynamicCode: '请输入动态码',
      PassengerSurname: '请输入旅客姓',
      PassengerName: '请输入旅客名',
      RefusalCause: '请填写拒绝原因！',
      PhoneBinding: '绑定的手机号不能空',
      EmailBinding: '绑定的邮箱不能空',
      Phone: '请输入正确的手机号',
      Email: '请输入正确的邮箱',
      VerificationTime: '每隔60s才能获取一次验证码',
      Account: '请输入账号',
      AccountEmpty: '账号不能为空',
      PasswordEmpty: '密码不能为空',
      PassengersNumbers: '旅客数量已上限,请联系客服',
      ManyPeople: '人数过多,请联系客服进行团购',
      ChangeReason: '改签原因不能为空',
      SeatNumbers: '乘客人数超过选择座位数',
      SelectSeat: '请为已选择的旅客选择座位'
    },
    succ: {
      SaveSucc: '保存成功！',
      CancelSucc: '取消成功！',
      ApprovalRefused: '审批拒绝！',
      ApproveSucc: '审批通过！',
      RefundSucc: '退票申请提交成功',
      ChangeSucc: '改签申请提交成功！',
      RegisteredSucc: '注册成功！',
      LoginSucc: '登陆成功！',
      ChangePasswordSucc: '密码修改成功',
      VerificationSucc: '验证码发送成功',
      AddSucc: '添加成功',
      ModifySucc: '修改成功',
      DeleteSucc: '删除成功',
      WeChat: '微信解绑成功'
    },
    confirm: {
      YesOrNoDelect: '是否确认删除',
      CreateOrder: '订单创建成功，欢迎您随时在订单详细中关注订单进度',
      ThankRemarks: '感谢您长期以来对力程商旅的信任与支持，为了更好提升用户差旅体验，力程商旅2018年10月30日上午9点起正式上线力程商旅2.0系统。用户可通过App Store自动更新, 安卓系统请联系本公司客服咨询，紧急联络电话15901610043。谢谢！'
    },
    loading: {
      load: '努力加载中',
      creatOrder: '订单创建中',
      PriceCalculation: '价格计算中'
    },
  },
  Categorys: {
    Young: '成人',
    Enfant: '儿童',
    Infant: '婴儿',
    economyClass: '经济舱',
    buissenesClass: '商务舱',
    firstClass: '头等舱',
    OnBusiness: '因公',
    OnPersonal: '因私',
    FlightService: '机票',
    HotelService: '酒店',
    TourService: '旅游',
    TrainService: '火车',
    SingleVoyage: '单程',
    RoundVoyage: '往返',
    WaitBooking: '待预订',
    WaitConfirm: '待确认',
    WaitPayment: '待支付',
    WaitDispose: '待处理',
    Finished: '已完成',
    Canceled: '已取消',
    Rejected: '已退回',
    Cannot: '暂不能',
    WaitApprove: '待审批',
    Discrete: '已拆分',
    WaitSubmit: '待提交',
    WaitRefund: '待退款',
    Male: '男',
    Female: '女',
    IDCard: "身份证",
    PassportCard: "护照",
    StudentCard: "学生证",
    OfficerCard: "军官证",
    HKMpermit: "港澳通行证",
    TaiWpermit: "台湾通行证",
    OtherCard: "其它",
    Company: '公司',
    User: '用户',
    HotelFare: '房费',
    TicketFare: '票面',
    MobileAuth: '手机账号',
    EmailAuth: '邮箱账号',
    AccountAuth: '账号密码',
    WeixinAuth: '微信授权',
    DynamicAuth: '动态密码',
    MessageNotify: '短信通知',
    MailNotify: '邮件通知',
    WechatNotify: '微信通知',
    AppNotify: 'App通知',
    Normal: '普通',
    OverseasStudent: '学生',
    Worker: '劳务',
    Immigrant: '新移民',
    '1138Categorys': '身份证',
    '1139Categorys': '护照',
    '1140Categorys': '学生证',
    '1141Categorys': '军官证',
    '1298Categorys': '港澳通行证',
    '1299Categorys': '台湾通行证',
    '1142Categorys': '其它',
    Finished: "已完成",

    AmendingFlight: '部分退票中',
    ChangeingFlight: '部分改签中',
    AmendingTrain: '部分退票中',
    ChangeingTrain: '部分改签中',
    AmendingHotel: '部分退房中',
    ChangeingHotel: '部分改签中',
    AmendingTour: '部分退团中',
    ChangeingTour: '部分改签中',
    AmendedFlight: '部分退票',
    ChangeedFlight: '部分改签',
    AmendedTrain: '部分退票',
    ChangeedTrain: '部分改签',
    AmendedHotel: '部分退房',
    ChangeedHotel: '部分改签',
    AmendedTour: '部分退团',
    ChangeedTour: '部分改签',
    AllAmendingFlight: '退票中',
    AllChangeingFlight: '改签中',
    AllBookingFlight: '购票中',
    AllAmendingTrain: '退票中',
    AllChangeingTrain: '改签中',
    AllBookingTrain: '购票中',
    AllAmendingHotel: '退房中',
    AllChangeingHotel: '改签中',
    AllBookingHotel: '预订中',
    AllAmendingTour: '退团中',
    AllChangeingTour: '改签中',
    AllBookingTour: '预订中',
    AllAmendedFlight: '退票成功',
    AllChangeedFlight: '改签成功',
    AllBookedFlight: '购票成功',
    AllAmendedTrain: '退票成功',
    AllChangeedTrain: '改签成功',
    AllBookedTrain: '购票成功',
    AllAmendedHotel: '退房成功',
    AllChangeedHotel: '改签成功',
    AllBookedHotel: '预订成功',
    AllAmendedTour: '退团成功',
    AllChangeedTour: '改签成功',
    AllBookedTour: '预订成功',


  },
  RegExp: {
    AccountReg: {
      isEmpty: '账户不能空',
      isFormat: '账户格式不正确'
    },
    PwdReg: {
      isEmpty: '密码不能空',
      isFormat: '密码格式不正确'
    },
    ConfigPwd: {
      isEmpty: '密码不能空',
      isFormat: '密码不一致'
    },
    VerificationCodeReg: {
      isEmpty: '验证码不能空',
    },
    DynamicCodeReg: {
      isEmpty: '动态码不能空',
    },
    ProtocolReg: {
      isFlag: '必须遵守协议'
    }
  }
}



// WEBPACK FOOTER //
// ./src/language/chinese.js